import { render, staticRenderFns } from "./LevelLabel.vue?vue&type=template&id=6a1d5647&scoped=true&"
import script from "./LevelLabel.vue?vue&type=script&lang=js&"
export * from "./LevelLabel.vue?vue&type=script&lang=js&"
import style0 from "./LevelLabel.vue?vue&type=style&index=0&id=6a1d5647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d5647",
  null
  
)

export default component.exports